import { isConfigReport, isFunnelReport } from 'reporting-data/tsTypes/reportTypes';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { isSearchReport, isTimeSeriesReport } from 'reporting-data/report/configReportGetters';
export const getIsReportValidForReportDataLimitDropdown = ({
  report
}) => {
  return isConfigReport(report) && getReportChartType(report) !== TABLE && !isTimeSeriesReport(report) && !isFunnelReport(report) && !isSearchReport(report);
};